import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createElementBlock as _createElementBlock, Transition as _Transition, Fragment as _Fragment } from "vue";
const _hoisted_1 = { key: 0 };
const _hoisted_2 = { class: "header" };
const _hoisted_3 = { class: "percentage" };
const _hoisted_4 = ["src"];
const _hoisted_5 = {
    key: 0,
    class: "cart"
};
const _hoisted_6 = {
    key: 0,
    class: "cart"
};
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAuth } from '@/composables/useAuth';
import { useAppState } from '@/composables/useAppState';
import { useCustomer } from '@/composables/useCustomer';
import { useVouchers } from '@/composables/useVouchers';
import CustomerLoadWait from './elements/CustomerLoadWait.vue';
import HeaderBlock from './elements/HeaderBlock.vue';
import MGDialog from './elements/MGDialog.vue';
import MGButton from './elements/MGButton.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'PaymentCompletePage',
    setup(__props) {
        const router = useRouter();
        useAuth();
        const state = useAppState();
        const { getCustomer } = useCustomer();
        const { getPayment, deleteCart, getAvailableVoucher, getCustomerVouchers } = useVouchers();
        const pendingPaymentType = ref(null);
        const error = ref(false);
        const showFulfilmentDialog = ref(false);
        const tries = ref(0);
        let voucherPollTries = 0;
        function clearPending() {
            localStorage.removeItem('pendingPayment');
            localStorage.removeItem('pendingPaymentType');
            localStorage.removeItem('pendingPaymentId');
            localStorage.removeItem('pendingVoucherId');
        }
        function onLoad() {
            // No payment in flight — this is a stale deeplink/back-navigation. Bounce to the wallet.
            if (localStorage.getItem('pendingPayment') !== 'true') {
                goToWallet();
                return;
            }
            pendingPaymentType.value = localStorage.getItem('pendingPaymentType');
            const pendingPaymentId = localStorage.getItem('pendingPaymentId');
            const pendingVoucherId = localStorage.getItem('pendingVoucherId');
            getCustomer();
            deleteCart();
            if (pendingVoucherId) {
                getAvailableVoucher(pendingVoucherId);
            }
            if (pendingPaymentType.value !== 's2s' && pendingPaymentId) {
                // Stripe or bank: poll the payment record until it's fulfilled
                checkPayment(pendingPaymentId);
            }
            else {
                // Saved to Spend (credit-paid), or no payment id to poll — just wait for the voucher to land
                waitForNewVoucher();
            }
        }
        function waitForNewVoucher() {
            getCustomerVouchers(() => {
                if (state.vouchers?.vouchers?.[0]?.isNewPurchase) {
                    goToWallet();
                    return;
                }
                if (voucherPollTries >= 5) {
                    showFulfilmentDialog.value = true;
                    return;
                }
                voucherPollTries += 1;
                setTimeout(waitForNewVoucher, 2000);
            }, null, false);
        }
        function goToWallet() {
            clearPending();
            // Hash-history redirects (Stripe/bank return) leave stale checkout/payment entries behind
            // router.replace only swaps out the current one; keep bouncing back-presses that land on them.
            window.addEventListener('popstate', blockBackIntoPayment);
            router.replace({ path: "/Wallet" });
        }
        function blockBackIntoPayment() {
            // Stays attached for the rest of the session; only acts when a back-step lands on a stale
            // checkout/payment entry, so it's harmless to leave listening (recovering itself fires another
            // popstate landing on /Wallet, which must NOT disarm this).
            if (location.hash.toLowerCase().includes('/vouchers/') || location.hash.toLowerCase().includes('/paymentcomplete')) {
                // Cancel the back-step rather than racing vue-router's own popstate handler with a replace.
                history.forward();
            }
        }
        function checkPayment(paymentId) {
            getPayment(paymentId, () => {
                const payment = state.payment;
                if (payment.fullfillmentError) {
                    error.value = true;
                    return;
                }
                if (payment.fulfilled) {
                    waitForNewVoucher();
                    return;
                }
                setTimeout(() => {
                    tries.value += 1;
                    if (tries.value >= (pendingPaymentType.value === 'bank' ? 250 : 6)) {
                        error.value = true;
                        return;
                    }
                    checkPayment(paymentId);
                }, 5000);
            });
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_chip = _resolveComponent("v-chip");
            const _component_v_col = _resolveComponent("v-col");
            const _component_v_row = _resolveComponent("v-row");
            const _component_v_progress_circular = _resolveComponent("v-progress-circular");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "Voucher",
                    color: "white",
                    bgcolor: "#281C3Bee",
                    border: "0"
                }),
                _createVNode(CustomerLoadWait, { customer: pendingPaymentType.value }, null, 8, ["customer"]),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (_unref(state).availableVoucher && !error.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                                _createElementVNode("div", {
                                    class: "header-image",
                                    style: _normalizeStyle('background-image: url(' + _unref(state).availableVoucher.cardUrl + ')')
                                }, [
                                    _createElementVNode("div", _hoisted_2, [
                                        _createVNode(_component_v_row, null, {
                                            default: _withCtx(() => [
                                                _createVNode(_component_v_col, { class: "v-col-9" }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("h1", null, _toDisplayString(_unref(state).availableVoucher.merchant.name), 1),
                                                        _createElementVNode("p", null, _toDisplayString(_unref(state).availableVoucher.description.substring(0, 200)) + "...", 1),
                                                        _createElementVNode("p", _hoisted_3, _toDisplayString(_unref(state).availableVoucher.effectiveDiscountPercentage) + "% cashback", 1),
                                                        (_unref(state).availableVoucher.online)
                                                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                                                key: 0,
                                                                variant: "outlined",
                                                                "background-color": "blue"
                                                            }, {
                                                                default: _withCtx(() => _cache[2] || (_cache[2] = [
                                                                    _createTextVNode("Online")
                                                                ])),
                                                                _: 1
                                                            }))
                                                            : _createCommentVNode("", true),
                                                        _cache[4] || (_cache[4] = _createTextVNode()),
                                                        (_unref(state).availableVoucher.inStore)
                                                            ? (_openBlock(), _createBlock(_component_v_chip, {
                                                                key: 1,
                                                                variant: "outlined"
                                                            }, {
                                                                default: _withCtx(() => _cache[3] || (_cache[3] = [
                                                                    _createTextVNode("In Store")
                                                                ])),
                                                                _: 1
                                                            }))
                                                            : _createCommentVNode("", true)
                                                    ]),
                                                    _: 1
                                                }),
                                                _createVNode(_component_v_col, { class: "v-col-3 logo-col" }, {
                                                    default: _withCtx(() => [
                                                        _createElementVNode("img", {
                                                            src: _unref(state).availableVoucher.merchant.logoUrl
                                                        }, null, 8, _hoisted_4)
                                                    ]),
                                                    _: 1
                                                })
                                            ]),
                                            _: 1
                                        })
                                    ])
                                ], 4)
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (pendingPaymentType.value && pendingPaymentType.value !== 'bank' && !error.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                                _cache[5] || (_cache[5] = _createElementVNode("h1", null, "Payment Complete", -1)),
                                _cache[6] || (_cache[6] = _createElementVNode("p", null, "Ordering your retail card . . .", -1)),
                                _createVNode(_component_v_progress_circular, {
                                    class: "mt-10",
                                    indeterminate: ""
                                })
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(_Transition, null, {
                    default: _withCtx(() => [
                        (pendingPaymentType.value === 'bank' && !error.value)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                                _cache[7] || (_cache[7] = _createElementVNode("h1", null, "Awaiting Payment", -1)),
                                _cache[8] || (_cache[8] = _createElementVNode("p", null, "Waiting for you to finish payment with your bank . . .", -1)),
                                _createVNode(_component_v_progress_circular, {
                                    class: "mt-10",
                                    indeterminate: ""
                                }),
                                _createVNode(MGButton, {
                                    class: "mt-10",
                                    fullWidth: "",
                                    noCaps: "",
                                    text: "I did not proceed with payment",
                                    onClick: goToWallet
                                })
                            ]))
                            : _createCommentVNode("", true)
                    ]),
                    _: 1
                }),
                _createVNode(MGDialog, {
                    modelValue: error.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event) => ((error).value = $event)),
                    title: "Fulfilment Error",
                    maxWidth: "400px",
                    contentHeight: "auto",
                    persistent: ""
                }, {
                    content: _withCtx(() => [
                        _createElementVNode("p", null, "We are very sorry, there was an issue fulfilling your order with " + _toDisplayString(_unref(state).availableVoucher?.merchant?.name) + ". Please contact help@moneyguided.com", 1)
                    ]),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Continue",
                            onClick: goToWallet
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"]),
                _createVNode(MGDialog, {
                    modelValue: showFulfilmentDialog.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event) => ((showFulfilmentDialog).value = $event)),
                    title: "Fulfilment Issue",
                    maxWidth: "400px",
                    contentHeight: "auto",
                    persistent: ""
                }, {
                    content: _withCtx(() => _cache[9] || (_cache[9] = [
                        _createElementVNode("p", null, "We're sorry - there has been an issue fulfilling your voucher order, our team has been informed and will contact you regarding refunds and next steps.", -1)
                    ])),
                    actions: _withCtx(() => [
                        _createVNode(MGButton, {
                            text: "Continue",
                            onClick: goToWallet
                        })
                    ]),
                    _: 1
                }, 8, ["modelValue"])
            ], 64));
        };
    }
});
